import { useContext } from 'react'

import { ContextoSesion, type EstadoSesion } from './contexto'

/**
 * Acceso a la sesión y a los permisos del usuario.
 *
 * Falla ruidosamente fuera del proveedor: es un error de montaje, y es mejor
 * verlo en la primera pantalla que descubrirlo por un permiso que siempre
 * devuelve false.
 */
export function useSesion(): EstadoSesion {
  const contexto = useContext(ContextoSesion)

  if (!contexto) {
    throw new Error('useSesion debe usarse dentro de <ProveedorSesion>.')
  }

  return contexto
}
